import React from 'react'

import { CiWarning } from "react-icons/ci";

function AccountSuspended() {
  return (
    <div style={{height:'300px'}}>
        <div className='text-center mt-5'>
            <CiWarning size={70} color='red' />
            <h3>Company Suspended</h3>
            <p className='text-black'>Your company has been suspended, Please contact support team.</p>
        </div>
    </div>
  )
}

export default AccountSuspended